import { X, Gift, LogIn, Trophy, Handshake, Gamepad2 } from "lucide-react";
import { useLang } from "@/i18n";

// "How to win FREE GIFTS" explainer — reward path + quick links.
export default function FreeGiftsModal({ onClose, onWeeklyWinners, onBrandPartnerships }) {
  const { t } = useLang();
  const steps = [
    { icon: LogIn, text: t("freeGiftsStep1") },
    { icon: Gamepad2, text: t("freeGiftsStep2") },
    { icon: Trophy, text: t("freeGiftsStep3") },
  ];
  return (
    <div className="fixed inset-0 z-[93] bg-black/85 flex items-start justify-center p-4 overflow-y-auto overscroll-contain safe-x safe-t safe-b" data-testid="free-gifts-modal" onClick={onClose}>
      <div className="pixel-card bg-[#141414] w-full max-w-md p-6 relative max-h-full overflow-y-auto pop-in my-auto" onClick={(e) => e.stopPropagation()}>
        <button data-testid="free-gifts-close" onClick={onClose} className="absolute top-3 right-3 text-white/60 hover:text-white"><X size={22} /></button>

        <div className="flex flex-col items-center text-center mb-4">
          <div className="w-14 h-14 rounded-2xl bg-[#4CAF50] flex items-center justify-center mb-2 ring-2 ring-white/90">
            <Gift size={30} strokeWidth={2.5} className="text-white" />
          </div>
          <h2 className="font-pixel text-base text-[#4CAF50] pixel-stroke">{t("freeGiftsTitle")}</h2>
          <p className="font-vt text-lg text-white/80 mt-1.5 leading-tight">{t("freeGiftsSubtitle")}</p>
        </div>

        <div className="space-y-2.5 mb-5">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={i} data-testid={`free-gifts-step-${i + 1}`} className="flex items-center gap-3 p-3 rounded-xl border-2 border-[#4CAF50]/30 bg-[#4CAF50]/5">
                <div className="shrink-0 w-9 h-9 rounded-full bg-[#4CAF50] text-white flex items-center justify-center"><Icon size={18} strokeWidth={2.5} /></div>
                <p className="font-vt text-base text-white/90 leading-tight">{s.text}</p>
              </div>
            );
          })}
        </div>

        <div className="flex flex-col gap-2.5">
          <button data-testid="free-gifts-see-winners" onClick={onWeeklyWinners} className="pixel-btn bg-[#FFB300] text-black w-full py-3.5 text-sm flex items-center justify-center gap-2">
            <Trophy size={18} strokeWidth={2.5} /> {t("freeGiftsSeeWinners")}
          </button>
          <button data-testid="free-gifts-see-partners" onClick={onBrandPartnerships} className="pixel-btn bg-[#FF1744] text-white w-full py-3 text-sm flex items-center justify-center gap-2">
            <Handshake size={18} strokeWidth={2.5} /> {t("becomeSponsor")}
          </button>
        </div>
      </div>
    </div>
  );
}
